import DigimaLogoFullSvg from '@/../assets/illustrations/digima-logo-full.svg';

export const DigimaLogoFull = () => (
  <DigimaLogoFullSvg width={186} height={65} testID="digima-logo-full" />
);
